import { SourceChain } from "lib/chains";
import { createContext } from "react";

export const SourceChainContext = createContext("mainnet" as SourceChain);
